module.exports = __webpack_public_path__ + "static/media/g.76d2e93d.png";